import './helpers/date-helpers';

import {StockroomFilterByCompany} from './components/pipes/stockroom-filter-by-company';

import {Injector, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser/';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import { PartnerService } from './services/lookups/partner.service';
import { CurrencyService } from './services/lookups/currency.service';


import {AppComponent} from './app.component';

import {ClientSettingsService} from './services/settings/client-settings.service';
import {SecurityService} from './services/settings/security.service';
import {ServiceLocator} from './services/base/service-locator';
import {BaseComponent} from './components/base/base.component';
import {ChooseCompanyStockroomComponent} from './components/ui/dialogs/choose-company-stockroom.component';
import {HomeNabavkeComponent} from './components/nabavke/home-nabavke/home-nabavke.component';
import {HomeComponent} from './components/home/home.component';
import {HomeRobnoKnjigovodstvoComponent} from './components/home/home-robno-knjigovodstvo/home-robno-knjigovodstvo.component';
import {AppConfigurationService} from 'app/services/base/app-configuration';
import {ProizvodnjaComponent} from './components/proizvodnja/home-proizvodnja/proizvodnja.component';

import {UserCalendarService} from 'app/services/lookups/user-calendar.service';
import {UserCalendarComponent} from './components/ui/user-calendar/user-calendar.component';
import {NewCalendarItemComponent} from './components/ui/user-calendar/new-calendar-item/new-calendar-item.component';
import {WebService} from './services/web/web.service';
import {DatePipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HomeOsnovnaSredstvaComponent} from './components/osnovnaSredstva/home-osnovna-sredstva/home-osnovna-sredstva.component';
import {DocumentService} from './services/document/document.service';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BMSSharedModule, HttpLoaderFactory} from './modules/bms-shared.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {RequestInterceptor} from './helpers/interceptors/request-interceptor';
import {LoginComponent} from './components/login/login.component';
import {MyCompanyComponent} from './components/ui/dialogs/my-company/my-company.component';
import { ProjektiModulComponent } from './components/projekti/home-projekti/projekti.component';
import { EotpremnicaServices } from './services/lookups/e-otpremnica.service';
import { PartnerItemService } from './services/lookups/partner-item.service';
import { KontaktOsobaService } from './services/lookups/kontakt-osoba.service';
import { AddressService } from './services/lookups/address.service';
@NgModule({
  declarations: [
    AppComponent, HomeComponent, BaseComponent, ChooseCompanyStockroomComponent,
    StockroomFilterByCompany, HomeNabavkeComponent, HomeRobnoKnjigovodstvoComponent, ProizvodnjaComponent, ProjektiModulComponent,
    UserCalendarComponent, NewCalendarItemComponent, HomeOsnovnaSredstvaComponent, LoginComponent, MyCompanyComponent
  ],
  imports: [
    BrowserModule, FormsModule, AppRoutingModule, BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'sr-Latn',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BMSSharedModule
  ],
  providers: [
    ClientSettingsService, SecurityService, AppConfigurationService, DatePipe, UserCalendarService, WebService,
    DocumentService, PartnerService, EotpremnicaServices, CurrencyService, PartnerItemService, KontaktOsobaService, AddressService,

    // {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.injector = this.injector;
    // const securityService: SecurityService = ServiceLocator.injector.get(SecurityService);
    // securityService.initGrantedActivities().subscribe();
  }
}
